// src/components/ui/pageLoader/PageLoader.jsx
import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import "primereact/resources/themes/lara-light-blue/theme.css"; // choose your theme
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./PageLoader.scss";

const PageLoader = () => {
  return (
    <div className="page-loader">
      <ProgressSpinner
        style={{ width: "50px", height: "50px" }}
        strokeWidth="4"
        animationDuration=".5s"
      />
    </div>
  );
};

export default PageLoader;